var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromisedTransactionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23858 2.23858 0 5 0H24V17C24 19.7614 21.7614 22 19 22H0V5Z",
    fill: "#AF1515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.79635C5 6.69956 6.65744 5 8.70228 5C10.1415 5 11.3883 5.84224 12 7.07291C12.6117 5.84224 13.8585 5 15.2977 5C17.3426 5 19 6.59397 19 8.79635C19 12.7222 12 17 12 17C12 17 5 12.7222 5 8.79635Z",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromisedTransactionIcon);
export default __webpack_public_path__ + "static/media/PromisedTransactionIcon.3163d34fc7167a4d55a63938d0d12e80.svg";
export { ForwardRef as ReactComponent };